import type { Persona, WorkOption } from '../types';
import { FreelanceShapes } from './FreelanceShapes';
import { WorkShapes } from './WorkShapes';
import { PersonaShapes } from './PersonaShapes';
import { EducationsShapes } from './EducationsShapes';
import { OthersShapes } from './OthersShapes';

interface ShapeRendererProps {
  persona: Persona;
  step: 1 | 2 | 3;
  selectedWorkOption: WorkOption | null;
}

export function ShapeRenderer({
  persona,
  step,
  selectedWorkOption,
}: ShapeRendererProps): JSX.Element | null {
  switch (persona) {
    case 'Freelance':
      return (
        <FreelanceShapes key="freelance" step={step} selectedWorkOption={selectedWorkOption} />
      );
    case 'Work':
      return <WorkShapes key="work" step={step} selectedWorkOption={selectedWorkOption} />;
    case 'Personal':
      return <PersonaShapes key="persona" step={step} selectedWorkOption={selectedWorkOption} />;
    case 'Education':
      return (
        <EducationsShapes key="education" step={step} selectedWorkOption={selectedWorkOption} />
      );
    case 'Others':
      return <OthersShapes key="others" step={step} selectedWorkOption={selectedWorkOption} />;
    default:
      return null;
  }
}
